import React from "react";
import { Accordion, Headline, SectionContent } from "../../../../components";
import * as S from "./Assistencias.Style";

const AssembleiasInclusasLeft = [
  {
    title: "Chaveiro",
    body: (
      <p>
        Se a porta for arrombada, a casa for assaltada ou simplesmente você
        perder as chaves, a gente manda alguém até você.
      </p>
    ),
  },
  {
    title: "Cobertura provisória de telhados",
    body: (
      <p>
        Em caso de emergência, enviamos um profissional para realizar a
        cobertura provisória do telhado com lona ou plástico.
      </p>
    ),
  },
  {
    title: "Eletricisita",
    body: (
      <p>
        A gente envia eletricista para reparar o que for necessário para
        restabelecer a energia elétrica ou solucionar problemas elétricos,
        dependendo do evento ocorrido.
      </p>
    ),
  },
];
const AssembleiasInclusasRight = [
  {
    title: "Encanador",
    body: (
      <p>
        Conte com serviços de hidráulica em casos de emergência ou sinistro para
        reparar vazamento interno que cause ou possa causar um alagamento. A
        assistência será realizada apenas em caso de vazamentos aparentes.
      </p>
    ),
  },
  {
    title: "Vidraceiro",
    body: (
      <p>
        Em caso de emergência, enviamos vidraceiro para consertar portas de
        vidro ou janelas externas de vidro. Caso não seja possível a execução do
        serviço será colocado um tapume. Lembramos que essa assistência não
        inclui blindex.
      </p>
    ),
  },
];

const AssembleiasParaVoceLeft = [
  {
    title: "Adaptação de imóvel para crianças",
    body: (
      <p>
        Um profissional irá analisar os cômodos e indicar serviços para deixar
        sua casa mais segura para crianças. Cobre também a mudança de móveis,
        intalação de itens de segurança e outros serviços gerais.
      </p>
    ),
  },
  {
    title: "Adaptação de imóvel para idosos",
    body: (
      <p>
        Essa assistência oferece a instalação de itens de segurança, troca de
        pia, torneiras, maçanetas, mudança de móveis e outros serviços que
        facilitam a vida do morador.
      </p>
    ),
  },
  {
    title: "Adaptação de imóvel para pessoa com deficiência",
    body: (
      <p>
        Instalação de itens de segurança, rampas, portas, troca de pia,
        torneiras e outros serviços gerais para facilitar a vida de quem precisa
        de cuidados especiais.
      </p>
    ),
  },
  {
    title: "Antivirus celular",
    body: (
      <p>
        Use esse serviço para evitar a perda de dados, bloquear e localizar seu
        smartphone em caso de perda, roubo ou furto. Mesmo longe do aparelho,
        você poderá apagar arquivos para que outras pessoas não vejam.
      </p>
    ),
  },
];
const AssembleiasParaVoceRight = [
  {
    title: "Assistência informática",
    body: (
      <p>
        Aproveite os serviços de suporte, diagnóstico e manutenção para resolver
        problemas emergenciais que impeçam o funcionamento de hardware,
        software, sistemas ou internet.
      </p>
    ),
  },
  {
    title: "Assistência Nutricional",
    body: (
      <p>
        Esse serviço telefônico oferece orientação nutricional por meio de
        estudantes de graduação em nutrição com supervisão de uma nutricionista
        para quem busca qualidade de vida e saúde.
      </p>
    ),
  },
  {
    title: "Cursos Online",
    body: (
      <p>
        Você pode fazer dois cursos online por ano. A lista de cursos estará
        disponível para você escolher.
      </p>
    ),
  },
];

const AssembleiasParaSuaCasaLeft = [
  {
    title: "Assistência bike",
    body: (
      <p>
        Para cuidar da sua bike, essa assistência cobre montagem de bicicleta,
        troca de pneu e corrente, ajuste ou troca dos cabos ou sapatas.
      </p>
    ),
  },
  {
    title: "Assistência fogão, geladeira, lavadora",
    body: (
      <p>
        Aproveite essa assistência para consertar equipamentos, como fogão,
        cooktop, fornos, geladeira, freezer, lavadoras/secadoras de louças ou
        roupas, tanquinho.
      </p>
    ),
  },
  {
    title: "Assistência TV, vídeo e som",
    body: (
      <p>
        Essa assistência oferece profissionais para o consertar equipamentos
        como TV, Vídeo Cassete, Blu-ray, DVD, Aparelho de Som e Home-Theater.
      </p>
    ),
  },
];
const AssembleiasParaSuaCasaRight = [
  {
    title: "Manutenção residencial",
    body: (
      <p>
        Com essa assistência, você conta com serviço de caçamba e profissionais
        para revisar a instalação elétrica, verificar vazamentos, instalar olho
        mágico, lubrificar fechaduras e dobradiças, fixar objetos nas paredes e
        trocar vidros.
      </p>
    ),
  },
  {
    title: "Vistoria de imóvel para combater a dengue",
    body: (
      <p>
        Quando necessário, enviamos um profissional para inspecionar e avaliar.
      </p>
    ),
  },
];

const AssembleiasParaPetsLeft = [
  {
    title: "Assistência pet (cães e gatos)",
    body: (
      <p>
        Assistência e transporte veterinário emergencial de cães e gatos,
        consultas na Rede Credenciada TEMPO USS, informações, hospedagem,
        aplicação de vacinas em casa e outras facilidades.
      </p>
    ),
  },
];
const AssembleiasParaPetsRight = [
  {
    title: "Orientações veterinárias por telefone",
    body: (
      <p>
        Nessa assistência, você tem atendimento veterinário por telefone com
        orientações sobre primeiros socorros e situações de baixa complexidade
        para guiar você nos cuidados com os seus bichinhos de estimação.
      </p>
    ),
  },
];

const Assistencias = () => {
  return (
    <>
      <SectionContent>
        <S.AccordionTitle
          as={Headline}
          nivel="3"
          styleAs="4"
          text="Já inclusas no seu contrato"
          leadMobile
        />
        <S.AccordionContainer>
          <Accordion listItems={AssembleiasInclusasLeft} />
          <Accordion listItems={AssembleiasInclusasRight} />
        </S.AccordionContainer>
        <S.AccordionTitle
          as={Headline}
          nivel="3"
          styleAs="4"
          text="Para você"
          leadMobile
        />
        <S.AccordionContainer>
          <Accordion listItems={AssembleiasParaVoceLeft} />
          <Accordion listItems={AssembleiasParaVoceRight} />
        </S.AccordionContainer>
        <S.AccordionTitle
          as={Headline}
          nivel="3"
          styleAs="4"
          text="Para sua casa e seus bens"
          leadMobile
        />
        <S.AccordionContainer>
          <Accordion listItems={AssembleiasParaSuaCasaLeft} />
          <Accordion listItems={AssembleiasParaSuaCasaRight} />
        </S.AccordionContainer>
        <S.AccordionTitle
          as={Headline}
          nivel="3"
          styleAs="4"
          text="Para seus cães e gatos"
          leadMobile
        />
        <S.AccordionContainer>
          <Accordion listItems={AssembleiasParaPetsLeft} />
          <Accordion listItems={AssembleiasParaPetsRight} />
        </S.AccordionContainer>
      </SectionContent>
    </>
  );
};

export default Assistencias;
